import { defineComponent } from '../utils/alpine'
import gsap from 'gsap'
import SplitText from 'gsap/SplitText'
import { waitForFonts } from '../utils/fonts'

export const Hero = defineComponent(() => ({
  async init() {
    // Wait for fonts to load before using SplitText
    await waitForFonts()

    const tl = gsap.timeline({ paused: true })

    if (this.$refs.title) {
      const split = new SplitText(this.$refs.title, {
        type: 'words',
        mask: 'words',
      })

      tl.from(split.words, {
        opacity: 0,
        yPercent: 120,
        rotate: 5,
        duration: 1,
        ease: 'power4.out',
        stagger: {
          each: 0.05,
          from: 'start',
        },
      })
    }

    if (this.$refs.copy) {
      tl.fromTo(
        this.$refs.copy,
        { yPercent: 10, opacity: 0 },
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
        },
        '-=0.4',
      )
    }

    if (!this.$refs.title && !this.$refs.copy) {
      return
    }

    if ((window as any).preloaderComplete) {
      tl.play()
    } else {
      window.addEventListener('preloader:complete', () => {
        tl.play()
      })
    }
  },

  discard() {},
}))
